import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "panel", "input", "results"]
  static values = { suggestionsUrl: String, feedUrl: String }

  #debounceTimer = null
  #selectedIndex = -1
  #fetchVersion = 0

  open(e) {
    e?.preventDefault()
    if (!this.backdropTarget.classList.contains("hidden")) return
    this.backdropTarget.classList.remove("hidden")
    this.panelTarget.classList.remove("hidden")
    this.inputTarget.focus()
    this.#fetch()
  }

  close() {
    clearTimeout(this.#debounceTimer)
    this.backdropTarget.classList.add("hidden")
    this.panelTarget.classList.add("hidden")
    this.inputTarget.value = ""
    this.resultsTarget.innerHTML = ""
    this.#selectedIndex = -1
    this.#fetchVersion++
  }

  query() {
    clearTimeout(this.#debounceTimer)
    this.#debounceTimer = setTimeout(() => this.#fetch(), 150)
  }

  select(e) {
    const li = e.target.closest("li[data-url]")
    if (li) window.location = li.dataset.url
  }

  highlight(e) {
    const li = e.target.closest("li[data-url]")
    if (!li) return
    const items = this.resultsTarget.querySelectorAll("li[data-url]")
    const index = Array.prototype.indexOf.call(items, li)
    if (index !== this.#selectedIndex) this.#select(items, index)
  }

  navigate(e) {
    const items = this.resultsTarget.querySelectorAll("li[data-url]")
    if (e.key === "Escape") { this.close(); return }
    if (e.key === "ArrowDown") { e.preventDefault(); this.#move(items, 1); return }
    if (e.key === "ArrowUp")   { e.preventDefault(); this.#move(items, -1); return }
    if (e.key === "Enter") {
      e.preventDefault()
      const selected = items[this.#selectedIndex]
      window.location = selected ? selected.dataset.url : this.#mentionsUrl()
    }
  }

  async #fetch() {
    const version = ++this.#fetchVersion
    const q = this.inputTarget.value.trim()

    const url = new URL(this.suggestionsUrlValue, window.location.origin)
    if (q.length > 0) url.searchParams.set("q", q)

    let html
    try {
      html = await fetch(url, { headers: { Accept: "text/html" } }).then(r => r.text())
    } catch {
      return
    }

    if (version !== this.#fetchVersion) return

    this.resultsTarget.innerHTML = html
    this.#select(this.resultsTarget.querySelectorAll("li[data-url]"), 0)
  }

  #move(items, dir) {
    if (!items.length) return
    this.#select(items, Math.max(0, Math.min(items.length - 1, this.#selectedIndex + dir)))
  }

  #select(items, index) {
    items[this.#selectedIndex]?.classList.remove("bg-ink-mist")
    this.#selectedIndex = index
    const selected = items[this.#selectedIndex]
    if (!selected) return
    selected.classList.add("bg-ink-mist")
    selected.scrollIntoView({ block: "nearest" })
  }

  #mentionsUrl() {
    const url = new URL(this.feedUrlValue, window.location.origin)
    url.searchParams.set("q", this.inputTarget.value.trim())
    return url.toString()
  }
}
